<script setup lang="ts">
import type { EmojiEntry } from "../../emojis/data";
import { useEmoji } from "../../emoji/useEmoji";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<{
  item: EmojiEntry;
}>();

const { shortCode, skinVariant } = useEmoji(props.item);
</script>

<template>
  <SuggestionListItem>
    <template #icon>
      <span class="font-emoji">
        {{ skinVariant.native }}
      </span>
    </template>
    {{ shortCode }}
  </SuggestionListItem>
</template>
